<script>
    import Field from "../../../Forms/Field.svelte";
    import {notifier} from "@beyonk/svelte-notifications";
    import { onMount } from "svelte";
    import {isMatch} from "lodash-es";
    import {confirm} from '../../Confirmation.svelte';

    export let assessment;
    export let assessment_model;
    export let section;

    let prev_section;
    let saved_data;

    let section_data = {};

    function save() {
        assessment_model.saveSectionResults(section, section_data).then((res) => {
            notifier.success("Report Section Saved")

            saved_data = JSON.parse(JSON.stringify(section_data));
            saved_data._rev = res._rev;
        });
    }



    function load_data(assessment, section) {
        // check for previous section
        if (prev_section != undefined && prev_section !== section) {
            checkUnsaved();
        }

        if (assessment.report_data[section.section_name]) {
            section_data = JSON.parse(JSON.stringify(assessment.report_data[section.section_name]));
            saved_data = JSON.parse(JSON.stringify(section_data));
        }

        prev_section = section;
    }

    function checkUnsaved() {
        if (!isMatch(section_data, saved_data)) {
            // save current variable before moving to new page
            let cache_section = prev_section;
            let cache_data = section_data;

            confirm("The previous section has unsaved changes, would you like to save?", false, {
                yes_button_text: "Save",
                title: "Unsaved Changes"
            }).then(() => {
                save_previous(cache_section, cache_data);
            }).catch(() => null);
        }
    }

    $: load_data($assessment, section);

    onMount(() => checkUnsaved);
</script>

<form on:submit|preventDefault={save}>
    {#each section.fields as field (field.id)}
        <Field
            label={field.name}
            name={field.name}
            type={field.type}
            required={field.required}
            dflt={field.dflt}
            choices={{static: field.options}}
            bind:value={section_data[field.name]}
            field_class="is-large"
        ></Field>
    {/each}
    <button class="button is-pulled-right is-success">Save</button>
</form>